export const SITE_BRAND_NAME = 'INRA' // Brand name for logos and headers
export const SITE_BRAND_TITLE = 'Independent Ranking' // Descriptive subtitle for additional context
export const SITE_FULL_TITLE = `${SITE_BRAND_NAME} - ${SITE_BRAND_TITLE}` // Full name for page titles and meta descriptions
export const SITE_PRIMARY_TAGLINE = 'Find and Share the Best Products' // Primary tagline for footers and about pages
export const SITE_SUPPORT_EMAIL = 'support@independentranking.com' // Contact email for support inquiries
export const SITE_SUPPORT_EMAIL_SENDER = `${SITE_BRAND_NAME} <${SITE_SUPPORT_EMAIL}>`
